/**
 * @generated SignedSource<<47b933c12d2785cf5cc024ec6bbe7e6a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RescheduleLessonInput = {
  clientMutationId?: string | null | undefined;
  lessonDuration?: number | null | undefined;
  lessonId: string;
  rearrangedDatetime: string;
};
export type RescheduleLessonMutation$variables = {
  input: RescheduleLessonInput;
};
export type RescheduleLessonMutation$data = {
  readonly rescheduleLesson: {
    readonly errors: any | null | undefined;
    readonly lesson: {
      readonly id: string;
      readonly lessonDuration: number | null | undefined;
      readonly rearrangedTimestamp: string | null | undefined;
    } | null | undefined;
    readonly success: boolean | null | undefined;
  } | null | undefined;
};
export type RescheduleLessonMutation = {
  response: RescheduleLessonMutation$data;
  variables: RescheduleLessonMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RescheduleLessonPayload",
    "kind": "LinkedField",
    "name": "rescheduleLesson",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "LessonNode",
        "kind": "LinkedField",
        "name": "lesson",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rearrangedTimestamp",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lessonDuration",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RescheduleLessonMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RescheduleLessonMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a3d91ed5a874ccc01ece04696473fcf4",
    "id": null,
    "metadata": {},
    "name": "RescheduleLessonMutation",
    "operationKind": "mutation",
    "text": "mutation RescheduleLessonMutation(\n  $input: RescheduleLessonInput!\n) {\n  rescheduleLesson(input: $input) {\n    success\n    errors\n    lesson {\n      id\n      rearrangedTimestamp\n      lessonDuration\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a2f51484021e7f7942ec7ff35d8ed5c5";

export default node;
